export default __webpack_public_path__ + "static/media/011-night.632083a0.svg";